// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Decco = require("decco/src/Decco.bs.js");
var Js_json = require("rescript/lib/js/js_json.js");
var Caml_obj = require("rescript/lib/js/caml_obj.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var URLUtils$SmartcutsMacros = require("../../bs-utils/src/URLUtils.bs.js");

function t_encode(v) {
  switch (v) {
    case /* Google */0 :
        return ["Google"];
    case /* Facebook */1 :
        return ["Facebook"];
    case /* Twitter */2 :
        return ["Twitter"];
    case /* LinkedIn */3 :
        return ["LinkedIn"];
    
  }
}

function t_decode(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "Facebook" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* Facebook */1
                  };
          }
      case "Google" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* Google */0
                  };
          }
      case "LinkedIn" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* LinkedIn */3
                  };
          }
      case "Twitter" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* Twitter */2
                  };
          }
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

var allOauthProviders = [
  /* Google */0,
  /* Facebook */1,
  /* Twitter */2,
  /* LinkedIn */3
];

function stringify(oauthProvider) {
  switch (oauthProvider) {
    case /* Google */0 :
        return "Google";
    case /* Facebook */1 :
        return "Facebook";
    case /* Twitter */2 :
        return "Twitter";
    case /* LinkedIn */3 :
        return "LinkedIn";
    
  }
}

function doesUrlMatchProvider(url, provider) {
  var tmp;
  switch (provider) {
    case /* Google */0 :
        tmp = [
          "com",
          "google"
        ];
        break;
    case /* Facebook */1 :
        tmp = [
          "com",
          "facebook"
        ];
        break;
    case /* Twitter */2 :
        tmp = [
          "com",
          "twitter"
        ];
        break;
    case /* LinkedIn */3 :
        tmp = [
          "com",
          "linkedin"
        ];
        break;
    
  }
  return Caml_obj.caml_equal(Belt_Option.map(URLUtils$SmartcutsMacros.$$URL.fromString(url), (function (url) {
                    return Belt_Array.slice(Belt_Array.reverse(url.hostname.split(".")), 0, 2);
                  })), tmp);
}

function getHostname(oauthProvider) {
  switch (oauthProvider) {
    case /* Google */0 :
        return "https://accounts.google.com";
    case /* Facebook */1 :
        return "https://www.facebook.com";
    case /* Twitter */2 :
        return "https://twitter.com";
    case /* LinkedIn */3 :
        return "https://www.linkedin.com";
    
  }
}

function maybeMatchingOAuthProviderFromUrl(url) {
  return Belt_Array.getBy(allOauthProviders, (function (provider) {
                switch (provider) {
                  case /* Google */0 :
                      return url.startsWith("https://accounts.google.com/o/oauth2/auth");
                  case /* Facebook */1 :
                      return /https:\/\/www\.facebook\.com\/v\.\d+\.\d+\/dialog\/oauth/.test(url);
                  case /* Twitter */2 :
                      return url.startsWith("https://api.twitter.com/oauth/");
                  case /* LinkedIn */3 :
                      return url.startsWith("https://www.linkedin.com/oauth/v2/authorization");
                  
                }
              }));
}

exports.t_encode = t_encode;
exports.t_decode = t_decode;
exports.allOauthProviders = allOauthProviders;
exports.stringify = stringify;
exports.doesUrlMatchProvider = doesUrlMatchProvider;
exports.getHostname = getHostname;
exports.maybeMatchingOAuthProviderFromUrl = maybeMatchingOAuthProviderFromUrl;
/* URLUtils-SmartcutsMacros Not a pure module */
